import React from 'react';
import PropTypes from 'prop-types';

export const Text = props => {
	const { Element, children, className, customStyles, noMargin, isMargin, id } = props;

	const styleProps = {
		color: props.color,
		background: props.background,
		fontSize: props.fontSize,
		textAlign: props.textAlign,
		fontFamily: props.fontFamily,
		width: props.width,
		lineHeight: props.lineHeight,
		maxWidth: props.maxWidth,
		paddingBottom: props.paddingBottom,
		paddingTop: props.paddingTop,
		paddingLeft: props.paddingLeft,
		paddingRight: props.paddingRight,
		marginBottom: props.marginBottom,
		marginTop: props.marginTop,
		marginLeft: props.marginLeft,
		marginRight: props.marginRight,
		borderTop: props.borderTop,
		borderRight: props.borderRight,
		borderBottom: props.borderBottom,
		borderLeft: props.borderLeft,
		fontWeight: props.fontWeight,
		letterSpacing: props.letterSpacing,
		whiteSpace: props.whiteSpace,
		textDecoration: props.textDecoration,
		textTransform: props.textTransform,
	};

	if (noMargin) {
		styleProps.marginTop = '0px';
		styleProps.marginBottom = '0px';
	}

	if (isMargin) {
		styleProps.margin = '0px auto';
	}

	return (
		<Element className={className} style={className ? { } : { ...styleProps, ...customStyles }} id={id}>
			{children}
		</Element>
	);
};

Text.propTypes = {
	children: PropTypes.any.isRequired,
	color: PropTypes.string,
	background: PropTypes.string,
	Element: PropTypes.string,
	fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	textAlign: PropTypes.string,
	borderTop: PropTypes.string,
	borderRight: PropTypes.string,
	borderLeft: PropTypes.string,
	borderBottom: PropTypes.string,
	fontFamily: PropTypes.string,
	fontWeight: PropTypes.string,
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	lineHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	paddingBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	paddingTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	paddingLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	paddingRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	marginBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	marginTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	marginLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	marginRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	letterSpacing: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	textDecoration: PropTypes.string,
	textTransform: PropTypes.string,
	whiteSpace: PropTypes.string,
	className: PropTypes.string,
	customStyles: PropTypes.object,
	noMargin: PropTypes.bool,
	isMargin: PropTypes.bool,
};

Text.defaultProps = {
	color: 'black',
	background: 'transparent',
	Element: 'div',
	fontSize: null,
	textAlign: 'inherit',
	fontFamily: null,
	width: null,
	lineHeight: null,
	maxWidth: null,
	paddingBottom: null,
	paddingTop: null,
	paddingLeft: null,
	paddingRight: null,
	marginBottom: null,
	marginTop: null,
	marginLeft: null,
	marginRight: null,
	className: null,
	customStyles: {},
	borderTop: null,
	borderRight: null,
	borderLeft: null,
	borderBottom: null,
	fontWeight: null,
	noMargin: false,
	letterSpacing: null,
	isMargin: false,
	whiteSpace: null,
	textDecoration: null,
};
